import { StorageService } from '@/utilities/storage/StorageService'
import { StorageEnum } from '@/utilities/storage/enums/StorageEnum'

export default {
  initializeTableSettings({ commit }) {
    const storage = new StorageService(StorageEnum.TABLE_SETTINGS)

    commit('clearTableSettings')

    const settings = storage.getObject()

    if (Array.isArray(settings)) {
      settings.forEach(data => commit('saveTableSettings', data))
    }
  },

  updateTableSettingsStorage({ state }) {
    const storage = new StorageService(StorageEnum.TABLE_SETTINGS)

    window.addEventListener('beforeunload', () => {
      storage.setObject(state.tableSettings)
    })
  },
}
